// import React, { useState } from 'react';
// import '../styling/global.css';
// import axios from 'axios';
// import { FaFacebook, FaLinkedin } from 'react-icons/fa';
// import tick from '../assets/tick.png';

// const ContactUs = () => {
//     const [formData, setFormData] = useState({
//         name: '',
//         email: '',
//         phone: '',
//         subject: '',
//         message: '',
//     });

//     const [loading, setLoading] = useState(false);
//     const [submitted, setSubmitted] = useState(false);

//     const handleChange = (e) => {
//         setFormData({ ...formData, [e.target.id]: e.target.value });
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();

//         setLoading(true);
//         try {
//             await axios.post('http://localhost:5000/api/contact', formData);
//             setSubmitted(true);
//         } catch (error) {
//             console.error('Error sending message:', error);
//         } finally {
//             setLoading(false);
//         }
//     };

//     return (
//         <div className="contact-page">
//             <section className="top-section">
//                 <h1>Contact Us</h1>
//                 <p>We'd love to hear from you</p>
//             </section>

//             <section className="contact-content">
//                 <div className="contact-info">
//                     <h2>Get in Touch</h2>

//                     <div className="info-item">
//                         <h3>Email</h3>
//                         <p>info@jsktechnologies.in</p>
//                     </div>

//                     <div className="info-item">
//                         <h3>Phone</h3>
//                         <p> For General queries: Call +91 967636200</p>
//                     </div>

//                     <div className="info-item">
//                         <h3>Location</h3>
//                         <p>
//                             59A-15-29, Badraiah Nagar, NTR Circle,
//                             Patamata, Vijayawada, Andhra Pradesh
//                             520010.
//                         </p>
//                     </div>

//                     <div className="info-item">
//                         <h3>Visitors Timings:</h3>
//                         <p>
//                             Mon – Fri, 7: 00 pm – 7: 30 pm
//                         </p>
//                     </div>


//                     <div className="social-media">
//                         <h3>Follow Us</h3>
//                         <div className="icons" style={{marginTop: "1.5rem"}}>
//                             <a href="https://www.facebook.com/JSKTechnologies" target="_blank" rel="noopener noreferrer"><FaFacebook /></a>
//                             <a href="https://www.linkedin.com/company/jsk-technologies/posts/?feedView=all" target="_blank" rel="noopener noreferrer"><FaLinkedin /></a>
//                         </div>
//                     </div>
//                 </div>

//                 <div className="contact-form">
//                     <h2>Send Us a Message</h2>

//                     {submitted ? (
//                         <div className="success-message-container">
//                           <img src={tick} alt="trustee logo" style={{width: "15%"}} />
//                           <h3>Message sent successfully!</h3>
//                           <p>Thank you for contacting us. We'll get back to you as soon as possible.</p>
//                     </div>
//                     ) : (
//                         <form onSubmit={handleSubmit}>
//                             {['name', 'email', 'phone', 'subject'].map((field) => (
//                                 <div className="form-group" key={field}>
//                                     <label htmlFor={field}>
//                                         {field.charAt(0).toUpperCase() + field.slice(1)}
//                                     </label>
//                                     <input
//                                         type={field === 'email' ? 'email' : 'text'}
//                                         id={field}
//                                         placeholder={`Your ${field}`}
//                                         value={formData[field]}
//                                         onChange={handleChange}
//                                         required
//                                     />
//                                 </div>
//                             ))}

//                             <div className="form-group">
//                                 <label htmlFor="message">Message</label>
//                                 <textarea
//                                     id="message"
//                                     rows="5"
//                                     placeholder="Your message"
//                                     value={formData.message}
//                                     onChange={handleChange}
//                                     required
//                                 ></textarea>
//                             </div>

//                             <button type="submit" className="submit-button" disabled={loading}>
//                                 {loading ? (
//                                     <span className="loading-content">
//                                         <span className="spinner" /> Sending...
//                                     </span>
//                                 ) : (
//                                     'Send Message'
//                                 )}
//                             </button>
//                         </form>
//                     )}
//                 </div>
//             </section>
//             <section className="map-section">
//                 <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d30602.377749260635!2d80.545921!3d16.511086000000002!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a35fb277d7d6575%3A0x4c2ea8439d01fa8d!2sJSK%20Technologies!5e0!3m2!1sen!2sin!4v1749899714011!5m2!1sen!2sin" width="100%" height="100%" style={{ border: 0 }} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade" title="JSK Technologies Map"></iframe>
//             </section>
//         </div>
//     );
// };

// export default ContactUs;






import React, { useState } from 'react';
import '../styling/global.css';
import { FaFacebook, FaLinkedin } from 'react-icons/fa';
import BackgroundEffect from '../components/BackgroundEffect';
import tick from '../assets/tick.png';
import img from '../assets/website_logo.png';

const ContactUs = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        subject: '',
        message: '',
    });

    const [loading, setLoading] = useState(false);
    const [submitted, setSubmitted] = useState(false);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.id]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        setLoading(true);
        setTimeout(() => {
            setLoading(false);
            setSubmitted(true);
        }, 2000); // Simulates 2-second delay
    };


    return (
        <div className="contact-page">
            <BackgroundEffect />
            <section className="top-section">
                <h1>Contact Us</h1>
                <p>We'd love to hear from you</p>
            </section>

            <section className="contact-content">
                <div className="contact-info">
                    <h2>Get in Touch</h2>

                    <div className="info-item">
                        <h3>Email</h3>
                        <p>info@jsktechnologies.in</p>
                    </div>

                    <div className="info-item">
                        <h3>Phone</h3>
                        <p> For General queries: Call +91 967636200</p>
                    </div>

                    <div className="info-item">
                        <h3>Location</h3>
                        <p>
                            59A-15-29, Badraiah Nagar, NTR Circle,
                            Patamata, Vijayawada, Andhra Pradesh
                            520010.
                        </p>
                    </div>

                    <div className="info-item">
                        <h3>Visitors Timings:</h3>
                        <p>
                            Mon – Fri, 7: 00 pm – 7: 30 pm
                        </p>
                    </div>


                    <div className="social-media">
                        <h3>Follow Us</h3>
                        <div className="icons" style={{ marginTop: "1.5rem" }}>
                            <a href="https://www.facebook.com/JSKTechnologies" target="_blank" rel="noopener noreferrer"><FaFacebook /></a>
                            <a href="https://www.linkedin.com/company/jsk-technologies/posts/?feedView=all" target="_blank" rel="noopener noreferrer"><FaLinkedin /></a>
                        </div>
                    </div>
                </div>

                {/* <div className="contact-form">
                    <h2>Send Us a Message</h2>

                    {submitted ? (
                        <div className="success-message-container">
                            <img src={tick} alt="trustee logo" style={{width: "15%"}} />
                            <h3>Message sent successfully!</h3>
                            <p>Thank you for contacting us. We'll get back to you as soon as possible.</p>
                        </div>
                    ) : (
                        <form onSubmit={handleSubmit}>
                            {['name', 'email', 'phone', 'subject'].map((field) => (
                                <div className="form-group" key={field}>
                                    <label htmlFor={field}>
                                        {field.charAt(0).toUpperCase() + field.slice(1)}
                                    </label>
                                    <input
                                        type={field === 'email' ? 'email' : 'text'}
                                        id={field}
                                        placeholder={`Your ${field}`}
                                        value={formData[field]}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                            ))}

                            <div className="form-group">
                                <label htmlFor="message">Message</label>
                                <textarea
                                    id="message"
                                    rows="5"
                                    placeholder="Your message"
                                    value={formData.message}
                                    onChange={handleChange}
                                    required
                                ></textarea>
                            </div>

                            <button type="submit" className="submit-button" disabled={loading}>
                                {loading ? (
                                    <span className="loading-content">
                                        <span className="spinner" /> Sending...
                                    </span>
                                ) : (
                                    'Send Message'
                                )}
                            </button>
                        </form>
                    )}
                </div> */}
                <div className='contact-form'>
                    <img src={img} alt="website_logo" className="hero-image" style={{width: "100%", marginTop: "10rem"}}/>

                </div>
            </section>
            <section className="map-section">
                <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d30602.377749260635!2d80.545921!3d16.511086000000002!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a35fb277d7d6575%3A0x4c2ea8439d01fa8d!2sJSK%20Technologies!5e0!3m2!1sen!2sin!4v1749899714011!5m2!1sen!2sin" width="100%" height="100%" style={{ border: 0 }} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade" title="JSK Technologies Map"></iframe>
            </section>
        </div>
    );
};

export default ContactUs;
